<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="bg_wrap">
      <topPiece></topPiece>
      <div class="container">
        <titleConfig
          :title="langSet == 'cn' ? '下载中心' : 'Download'"
          :type="2"
        ></titleConfig>
        <div class="down_list">
          <div
            class="down_item flex flex_items_center flex_content_sb flex_wrap"
            v-for="(item, index) in list"
            :key="index"
            @click="downLoadFile(item)"
          >
            <div class="down_left flex flex_items_center">
              <img
                class="down_icon"
                v-if="item.ext == 'doc'"
                :src="require('../../assets/imgs/d_icon5.png')"
                alt=""
              />
              <img
                class="down_icon"
                v-if="item.ext == 'pdf'"
                :src="require('../../assets/imgs/d_icon2.png')"
                alt=""
              />
              <img
                class="down_icon"
                v-if="item.ext == 'pptx'"
                :src="require('../../assets/imgs/d_icon3.png')"
                alt=""
              />
              <div class="down_title">
                {{ item.title }}
              </div>
            </div>
            <div class="down_text">{{ langSet == 'cn' ? '下载文件':'Download File' }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import topPiece from "@/components/topPiece.vue";
import titleConfig from "@/components/title.vue";
import { downloadCenter } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    topPiece,
    titleConfig,
  },
  data() {
    return {
      langSet: "",
      list: [],
      metaData: {}
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    //25.6.10 获取下载列表 dxm
    this.getDownloadCenterList();
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getDownloadCenterList() {
      let data = {
        lang: this.langSet
      }
      const res = await downloadCenter(data);
      this.list = res.data.lists;
    },
    //25.6.10 文件下载 dxm
    downLoadFile(item) {
      window.location.href = item.fileurl;
    },
  },
};
</script>
<style lang="scss" scoped>
.down_list {
  padding-bottom: 100px;
  .down_item {
    width: calc((100% - 40px) / 2);
    height: 140px;
    padding: 0 40px;
    box-sizing: border-box;
    background: #f7f8fa;
    font-size: 16px;
    color: #333;
    cursor: pointer;
    margin: 40px 40px 0 0;
    .down_title {
      flex: 1;
      color: #000;
      font-size: 20px;
      font-weight: 500;
    }
    .down_icon {
      width: 60px;
      height: 60px;
      box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      margin-right: 20px;
    }
    .down_text {
      padding-left: 20px;
      background: url("../../assets/imgs/d_icon.png") no-repeat;
    }
    &:hover {
      .down_text {
        color: #e62344;
        background: url("../../assets/imgs/d_icon_active.png") no-repeat;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .down_list {
    padding-top: 0.62rem;
    padding-bottom: 1.15rem;
    .down_item {
      width: 100%;
      height: 2.4rem;
      color: #004190;
      padding: 0.38rem;
      font-size: 0.27rem;
      margin: 0 0 0.38rem 0;
      .down_left{
        width: 100%;
      }
      .down_title {
        font-size: 0.29rem;
      }
      .down_icon {
        width: 0.96rem;
        height: 0.96rem;
        box-shadow: 0rem 0.12rem 0.19rem 0rem rgba(0, 0, 0, 0.1);
        border-radius: 0.12rem;
        margin-right: 0.29rem;
      }
      .down_text {
        width: 100%;
        text-align: right;
        background: url("../../assets/imgs/d_icon_blue.png") no-repeat 3.8rem;
        background-size: contain;
      }
    }
  }
}
</style>